const configs = {
  nextApiPrefix: 'app',
  serviceWorker: 'service-worker.js',
};
module.exports = configs;
